<template>
  <div>
    <zm-drawer
      :visible="visible"
      :title="title"
      :footer="footer"
      :width="'55%'"
      :placement="placement"
      @cancel="cancel"
      class="modal"
      id="modal"
    >
      <div slot="drawerBody" style="height: 100%">
        <div class="drawerBody">
          <a-form-model :model="form" ref="formModel" :rules="rules" labelAlign="right">
            <a-spin :spinning="loading">
              <a-tabs @change="changeParentTabs" v-model="parentTabsKey" defaultActiveKey="basicInformationP" class="tabb">
                <a-tab-pane forceRender tab="基础信息" key="basicInformationP">
                  <div class="fieldDiv">
                    <a-tabs @change="changBasicChildrenTabs" v-model="basicChildrenTabsKey">
                      <a-tab-pane forceRender tab="基本信息" key="basicInformation">
                        <div class="fieldDiv">
                          <div class="basicParameters">
                            <a-row :gutter="10">
                              <a-col :span="8">
                                <a-form-model-item
                                  prop="pName">
                                  <a-tooltip>
                                    <template slot="title">
                                      父设备
                                    </template>
                                    <span
                                      class="spanRequired titleSpan"
                                      :style="labelCol.style"
                                      style="display: inline-block">父设备：</span>
                                  </a-tooltip>
                                  <a-input
                                    :style="wrapperCol.style"
                                    autocomplete="off"
                                    :disabled="true"
                                    v-model="form.pName"
                                  />
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                                <a-form-model-item
                                  prop="name"
                                  :rules="{ required: true, message: '请输入设备名称!', trigger: 'blur' }">
                                  <a-tooltip>
                                    <template slot="title">
                                      设备名称
                                    </template>
                                    <span
                                      class="spanRequired titleSpan"
                                      :style="labelCol.style"
                                      style="display: inline-block">设备名称：</span>
                                  </a-tooltip>
                                  <a-input
                                    :style="wrapperCol.style"
                                    placeholder="请输入设备名称"
                                    autocomplete="off"
                                    :disabled="false"
                                    v-model="form.name"
                                  />
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                                <a-form-model-item
                                  prop="sign"
                                  :rules="{ required: true, message: '请选择是否虚拟设备!', trigger: 'change' }">
                                  <a-tooltip>
                                    <template slot="title">
                                      是否虚拟设备
                                    </template>
                                    <span
                                      class="spanRequired titleSpan"
                                      :style="labelCol.style"
                                      style="display: inline-block">是否虚拟设备：</span>
                                  </a-tooltip>
                                  <a-select
                                    :style="wrapperCol.style"
                                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                    v-model="form.sign"
                                    :allowClear="true"
                                    placeholder="请选择是否虚拟设备">
                                    <a-select-option v-for="(item, index) in yesOrNoSignList" :key="index" :value="item.id">
                                      {{ item.name }}
                                    </a-select-option>
                                  </a-select>
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="8" v-if="type === 'add' || type === 'copy'">
                                <a-form-model-item
                                  prop="equipmentAmount"
                                  :rules="{ required: true, message: '请输入设备数量!', trigger: 'blur' }">
                                  <a-tooltip>
                                    <template slot="title">
                                      设备数量
                                    </template>
                                    <span
                                      class="spanRequired titleSpan"
                                      :style="labelCol.style"
                                      style="display: inline-block">设备数量：</span>
                                  </a-tooltip>
                                  <a-input
                                    :disabled="sonId !== ''"
                                    :style="wrapperCol.style"
                                    placeholder="请输入设备数量"
                                    autocomplete="off"
                                    v-model="form.equipmentAmount"
                                  />
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="8" v-else>
                                <a-form-model-item
                                  prop="equipmentNumber">
                                  <a-tooltip>
                                    <template slot="title">
                                      设备编号
                                    </template>
                                    <span
                                      class="titleSpan"
                                      :style="labelCol.style"
                                      style="display: inline-block">设备编号：</span>
                                  </a-tooltip>
                                  <a-input
                                    :style="wrapperCol.style"
                                    placeholder=""
                                    autocomplete="off"
                                    v-model="form.equipmentNumber"
                                    disabled
                                  />
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                                <a-form-model-item
                                  prop="unit"
                                  :rules="{ required: true, message: '请选择单位!', trigger: 'change' }">
                                  <a-tooltip>
                                    <template slot="title">
                                      单位
                                    </template>
                                    <span
                                      class="spanRequired titleSpan"
                                      :style="labelCol.style"
                                      style="display: inline-block">单位：</span>
                                  </a-tooltip>
                                  <a-select
                                    show-search
                                    :filter-option="filterOption"
                                    :style="wrapperCol.style"
                                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                    dropdownClassName="antSelectDropdownMenu200"
                                    :dropdown-style="{ maxHeight: '200px', overflow: 'auto' }"
                                    v-model="form.unit"
                                    :allowClear="true"
                                    placeholder="请选择单位">
                                    <a-select-option v-for="(item, index) in unitList" :key="index" :value="item.code">
                                      {{ item.name }}
                                    </a-select-option>
                                  </a-select>
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                                <a-form-model-item
                                  :rules="{ required: true, message: '请输入内部编码!', trigger:'blur' }"
                                  prop="interiorCode">
                                  <a-tooltip>
                                    <template slot="title">
                                      内部编码
                                    </template>
                                    <span class="spanRequired titleSpan" :style="labelCol.style" style="display: inline-block">内部编码：</span>
                                  </a-tooltip>
                                  <a-input
                                    :style="wrapperCol.style"
                                    placeholder="请输入内部编码"
                                    autocomplete="off"
                                    :disabled="false"
                                    v-model="form.interiorCode"
                                  />
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                                <a-form-model-item
                                  :rules="{ required: true, message: '请选择设备分类!', trigger:'change' }"
                                  prop="equipmentType">
                                  <a-tooltip>
                                    <template slot="title">
                                      设备分类
                                    </template>
                                    <span
                                      class="spanRequired titleSpan"
                                      :style="labelCol.style"
                                      style="display: inline-block">设备分类：</span>
                                  </a-tooltip>
                                  <a-tree-select
                                    :style="wrapperCol.style"
                                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                    @change="changeEquipmentType"
                                    v-model="form.equipmentType"
                                    style="width: 100%"
                                    placeholder="请选择设备分类"
                                    allow-clear
                                    show-search
                                    :filterTreeNode="filterTreeNode"
                                    :dropdown-style="{ maxHeight: '200px', overflow: 'auto' }"
                                    :treeData="equipmentClassList"
                                    :replaceFields="{
                                      title: 'name',
                                      key: 'code',
                                      value: 'code'
                                    }"
                                    :disabled="type === 'edit' && (searchDeviceType ? !$auth('gasEquipmentLedger.changeEquipmentType') : !$auth('centralizedManagement.changeEquipmentType'))"
                                  ></a-tree-select>
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                                <a-form-model-item
                                  prop="equipmentStatus"
                                  :rules="{ required: true, message: '请选择设备状态!', trigger: 'change' }">
                                  <a-tooltip>
                                    <template slot="title">
                                      设备状态
                                    </template>
                                    <span
                                      class="spanRequired titleSpan"
                                      :style="labelCol.style"
                                      style="display: inline-block">设备状态：</span>
                                  </a-tooltip>
                                  <a-select
                                    show-search
                                    :filter-option="filterOption"
                                    :style="wrapperCol.style"
                                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                    dropdownClassName="antSelectDropdownMenu200"
                                    :dropdown-style="{ maxHeight: '200px', overflow: 'auto' }"
                                    @change="changeEquipmentStatus"
                                    v-model="form.equipmentStatus"
                                    :allowClear="true"
                                    placeholder="请选择设备状态">
                                    <a-select-option v-for="(item, index) in equipmentStatusList" :key="index" :value="item.code">
                                      {{ item.name }}
                                    </a-select-option>
                                  </a-select>
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                                <a-form-model-item
                                  :rules="{ required: true, message: '请输入规格型号!', trigger:'blur' }"
                                  prop="specification">
                                  <a-tooltip>
                                    <template slot="title">
                                      规格型号
                                    </template>
                                    <span class="spanRequired titleSpan" :style="labelCol.style" style="display: inline-block">规格型号：</span>
                                  </a-tooltip>
                                  <a-input
                                    :style="wrapperCol.style"
                                    placeholder="请输入规格型号"
                                    autocomplete="off"
                                    v-model="form.specification"
                                  />
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                                <a-form-model-item
                                  prop="subcompanyid"
                                  :rules="{ required: true, message: '请选择公司名称!', trigger: 'change' }">
                                  <a-tooltip>
                                    <template slot="title">
                                      公司名称
                                    </template>
                                    <span
                                      class="spanRequired titleSpan"
                                      :style="labelCol.style"
                                      style="display: inline-block">公司名称：</span>
                                  </a-tooltip>
                                  <a-tree-select
                                    :style="wrapperCol.style"
                                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                    v-model="form.subcompanyid"
                                    placeholder="请选择公司名称"
                                    style="width: 100%"
                                    allow-clear
                                    show-search
                                    :filterTreeNode="filterTreeNode"
                                    :dropdown-style="{ maxHeight: '200px', overflow: 'auto' }"
                                    :treeData="companyNameList"
                                    :replaceFields="{
                                      title: 'url',
                                      key: 'id',
                                      value: 'id'
                                    }"
                                    @change="changeCompany"
                                    :disabled="type === 'edit' ? true : !!dataTabsModel"
                                  ></a-tree-select>
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                                <a-spin :spinning="companyLoading">
                                  <a-form-model-item
                                    prop="usedeptid"
                                    :rules="{ required: form.equipmentStatus === 'sb_sbzt_01', message: '请选择使用部门!', trigger: 'change' }">
                                    <a-tooltip>
                                      <template slot="title">
                                        使用部门
                                      </template>
                                      <span
                                        class="titleSpan"
                                        :class="(form.equipmentStatus === 'sb_sbzt_01') ? 'spanRequired' : ''"
                                        :style="labelCol.style"
                                        style="display: inline-block">使用部门：</span>
                                    </a-tooltip>
                                    <a-tree-select
                                      :style="wrapperCol.style"
                                      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                      v-model="form.usedeptid"
                                      style="width: 100%"
                                      placeholder="请选择使用部门"
                                      show-search
                                      :filterTreeNode="filterTreeNode"
                                      allow-clear
                                      :dropdown-style="{ maxHeight: '200px', overflow: 'auto' }"
                                      :treeData="userDepartmentList"
                                      :replaceFields="{
                                        title: 'url',
                                        key: 'id',
                                        value: 'id'
                                      }"
                                      @change="changeUseDept"
                                      :disabled="dataTabsModel ? true : false"
                                    ></a-tree-select>
                                  </a-form-model-item>
                                </a-spin>
                              </a-col>
                              <a-col :span="8">
                                <a-spin :spinning="usedeptLoading">
                                  <a-form-model-item>
                                    <a-tooltip>
                                      <template slot="title">
                                        使用人员
                                      </template>
                                      <span class="titleSpan" :style="labelCol.style" style="display: inline-block">使用人员：</span>
                                    </a-tooltip>
                                    <!--                                    <span v-if="type === 'edit' && !showPrincipalName && (userOfServiceList.findIndex(item => item.id === form.principalId) === -1)">找不到</span>-->
                                    <a-select
                                      show-search
                                      :filter-option="filterOption"
                                      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                      dropdownClassName="antSelectDropdownMenu200"
                                      :dropdown-style="{ maxHeight: '200px', overflow: 'auto' }"
                                      v-model="form.principalId"
                                      :allowClear="true"
                                      placeholder="请选择使用人员"
                                      @change="changeUseDeptPersonnel"
                                      :style="((type !== 'add' || dataTabsModel) && !showPrincipalName && form.principalId && (userOfServiceList.findIndex(item => item.id === form.principalId) === -1)) ? {color: 'red', width: 'calc(100% - 106px)'} : {width: 'calc(100% - 106px)'}"
                                      :disabled="dataTabsModel ? true : false"
                                    >
                                      <!--                                -->
                                      <a-select-option value="null">
                                        其他
                                      </a-select-option>
                                      <a-select-option v-for="(item, index) in userOfServiceList" :key="index" :value="item.id">
                                        {{ item.lastname }}
                                      </a-select-option>
                                    </a-select>
                                  </a-form-model-item>
                                </a-spin>
                              </a-col>
                              <a-col :span="8" :offset="16" v-if="showPrincipalName">
                                <a-input
                                  placeholder=""
                                  autocomplete="off"
                                  :disabled="dataTabsModel ? true : false"
                                  v-model="form.principalName"
                                  style="width: calc(100% - 106px); margin-left: 101px;margin-bottom: 12px !important;"
                                />
                              </a-col>
                              <a-col :span="8">
                                <a-form-model-item
                                  prop="relevantdeptid"
                                  :rules="{ required: true, message: '请选择归口部门!', trigger: 'change' }">
                                  <a-tooltip>
                                    <template slot="title">
                                      归口部门
                                    </template>
                                    <span
                                      class="spanRequired titleSpan"
                                      :style="labelCol.style"
                                      style="display: inline-block">归口部门：</span>
                                  </a-tooltip>
                                  <a-select
                                    show-search
                                    :filter-option="filterOption"
                                    :style="wrapperCol.style"
                                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                    @change="changeRelevantDept"
                                    v-model="form.relevantdeptid"
                                    dropdownClassName="antSelectDropdownMenu200"
                                    :dropdown-style="{ maxHeight: '200px', overflow: 'auto' }"
                                    :allowClear="true"
                                    :disabled="dataTabsModel ? true : false"
                                    placeholder="请选择归口部门">
                                    <a-select-option
                                      v-for="(item, index) in relevantDepartmentList"
                                      :key="index"
                                      :value="item.deptId">
                                      {{ item.departmentname }}
                                    </a-select-option>
                                  </a-select>
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                                <a-spin :spinning="relevantdeptLoading">
                                  <a-form-model-item prop="relevantdeptUserId">
                                    <a-tooltip>
                                      <template slot="title">
                                        归口部门负责人
                                      </template>
                                      <span
                                        class="titleSpan"
                                        :style="labelCol.style"
                                        style="display: inline-block">归口部门负责人：</span>
                                    </a-tooltip>
                                    <a-select
                                      show-search
                                      :filter-option="filterOption"
                                      :style="wrapperCol.style"
                                      :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                      v-model="form.relevantdeptUserId"
                                      :allowClear="true"
                                      placeholder="请选择归口部门负责人"
                                      dropdownClassName="antSelectDropdownMenu200"
                                      :dropdown-style="{ maxHeight: '200px', overflow: 'auto' }"
                                      @change="changeCentralizeDeptPersonnel"
                                      :disabled="dataTabsModel ? true : false">
                                      <a-select-option
                                        v-for="(item, index) in centralizedDepartmentCenter"
                                        :key="index"
                                        :value="item.id">
                                        {{ item.lastname }}
                                      </a-select-option>
                                    </a-select>
                                  </a-form-model-item>
                                </a-spin>
                              </a-col>
                              <a-col :span="8">
                                <a-form-model-item
                                  :rules="{ required: true, message: '请输入设备品牌!', trigger:'change' }"
                                  prop="brand">
                                  <a-tooltip>
                                    <template slot="title">
                                      设备品牌
                                    </template>
                                    <span class="spanRequired titleSpan" :style="labelCol.style" style="display: inline-block">设备品牌：</span>
                                  </a-tooltip>
                                  <a-input
                                    :style="wrapperCol.style"
                                    placeholder="请输入设备品牌"
                                    autocomplete="off"
                                    :disabled="false"
                                    v-model="form.brand"
                                  />
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                                <a-form-model-item prop="assetNumber">
                                  <a-tooltip>
                                    <template slot="title">
                                      资产卡片号
                                    </template>
                                    <span class="titleSpan" :style="labelCol.style" style="display: inline-block">资产卡片号：</span>
                                  </a-tooltip>
                                  <a-input
                                    :style="wrapperCol.style"
                                    placeholder="请输入资产卡片号"
                                    autocomplete="off"
                                    v-model="form.assetNumber"
                                    :disabled="dataTabsModel ? true : false"
                                  />
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                                <a-form-model-item prop="entryDate">
                                  <a-tooltip>
                                    <template slot="title">
                                      首次投用日期
                                    </template>
                                    <span class="titleSpan" :style="labelCol.style" style="display: inline-block">首次投用日期：</span>
                                  </a-tooltip>
                                  <a-date-picker
                                    :style="wrapperCol.style"
                                    :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
                                    :showToday="false"
                                    format="YYYY-MM-DD"
                                    placeholder="请选择投用日期"
                                    v-model="form.entryDate"
                                    style="width: 100%"
                                  />
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                                <a-form-model-item prop="retirementDate">
                                  <a-tooltip>
                                    <template slot="title">
                                      报废日期
                                    </template>
                                    <span class="titleSpan" :style="labelCol.style" style="display: inline-block">报废日期：</span>
                                  </a-tooltip>
                                  <a-date-picker
                                    :style="wrapperCol.style"
                                    :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
                                    :showToday="false"
                                    format="YYYY-MM-DD"
                                    placeholder="请选择报废日期"
                                    v-model="form.retirementDate"
                                    style="width: 100%"
                                  />
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                                <a-form-model-item prop="importanceType">
                                  <a-tooltip>
                                    <template slot="title">
                                      重要分类
                                    </template>
                                    <span class="titleSpan" :style="labelCol.style" style="display: inline-block">重要分类：</span>
                                  </a-tooltip>
                                  <a-select
                                    :style="wrapperCol.style"
                                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                    v-model="form.importanceType"
                                    :allowClear="true"
                                    placeholder="请选择重要分类">
                                    <a-select-option
                                      v-for="(item, index) in importantClassificationList"
                                      :key="index"
                                      :value="item.id">
                                      {{ item.name }}
                                    </a-select-option>
                                  </a-select>
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="8">
                                <a-form-model-item
                                  prop="displayType"
                                  :rules="{ required: true, message: '请选择展示方式!', trigger: 'change' }">
                                  <a-tooltip>
                                    <template slot="title">
                                      展示方式
                                    </template>
                                    <span
                                      class="spanRequired titleSpan"
                                      :style="labelCol.style"
                                      style="display: inline-block">展示方式：</span>
                                  </a-tooltip>
                                  <a-select
                                    :style="wrapperCol.style"
                                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                    v-model="form.displayType"
                                    :allowClear="true"
                                    placeholder="请选择展示方式">
                                    <a-select-option
                                      v-for="(item, index) in displayModeList"
                                      :key="index"
                                      :value="item.id">
                                      {{ item.name }}
                                    </a-select-option>
                                  </a-select>
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="24">
                                <a-form-model-item prop="peculiarity">
                                  <a-tooltip>
                                    <template slot="title">
                                      特性选择
                                    </template>
                                    <span
                                      class="titleSpan"
                                      :style="labelCol.style"
                                      style="display: inline-block">特性选择：</span>
                                  </a-tooltip>
                                  <a-checkbox-group
                                    :style="wrapperCol.style"
                                    v-model="form.peculiarity"
                                    name="checkboxgroup"
                                    :options="plainOptions"
                                  />
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="24">
                                <a-form-model-item prop="address">
                                  <a-tooltip>
                                    <template slot="title">
                                      设施位置/地址
                                    </template>
                                    <span class="titleSpan" :style="labelCol.style" style="display: inline-block">设施位置/地址：</span>
                                  </a-tooltip>
                                  <a-input
                                    :style="wrapperCol.style"
                                    placeholder="请输入设施位置/地址"
                                    autocomplete="off"
                                    :disabled="false"
                                    v-model="form.address"
                                  />
                                </a-form-model-item>
                              </a-col>
                              <a-col :span="24">
                                <a-form-model-item prop="remark">
                                  <a-tooltip>
                                    <template slot="title">
                                      备注
                                    </template>
                                    <span class="titleSpan" :style="labelCol.style" style="display: inline-block">备注：</span>
                                  </a-tooltip>
                                  <a-textarea
                                    :style="wrapperCol.style"
                                    placeholder="请输入备注"
                                    autocomplete="off"
                                    :disabled="false"
                                    v-model="form.remark"
                                  />
                                </a-form-model-item>
                              </a-col>
                            </a-row>
                          </div>
                        </div>
                      </a-tab-pane>
                      <a-tab-pane forceRender v-for="(item, index) in form.systemValueInputSelectList" :tab="item.pName" :key="item.pName">
                        <div class="fieldDiv">
                          <div class="otherParameters">
                            <a-row :gutter="10">
                              <a-col :span="8" v-for="(item2, index2) in item.children" :key="index2">
                                <a-form-model-item
                                  :prop="'systemValueInputSelectList.' + index + '.children.' + index2 + '.vaules'"
                                  :rules="{required: item2.status === 1 && item2.requiredState && item.required, message: item2.valueType === 1 ? `请输入${item2.name}` : `请选择${item2.name}`, trigger: item2.valueType === 1 ? 'blur' : 'change'}">
                                  <a-tooltip>
                                    <template slot="title">
                                      {{ item2.name }}
                                    </template>
                                    <span
                                      class="titleSpan"
                                      :class="(item2.status === 1 && item2.requiredState) ? 'spanRequired' : ''"
                                      :style="labelCol.style"
                                      style="display: inline-block">{{ item2.name }}：</span>
                                  </a-tooltip>
                                  <a-input
                                    :style="wrapperCol.style"
                                    v-if="item2.valueType === 1"
                                    :placeholder="`请输入${item2.name}`"
                                    autocomplete="off"
                                    :disabled="item2.status === 2"
                                    v-model="item2.vaules"
                                    @change="(value) => changeParamsInput(value,index, index2, 'systemValueInputSelectList')"
                                  />
                                  <a-select
                                    v-else-if="item2.valueType === 2"
                                    :style="wrapperCol.style"
                                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                    dropdownClassName="antSelectDropdownMenu200"
                                    :dropdown-style="{ maxHeight: '200px', overflow: 'auto' }"
                                    v-model="item2.vaules"
                                    :disabled="item2.status === 2"
                                    :allowClear="true"
                                    :placeholder="`请选择${item2.name}`"
                                    @change="(value) => changeParamsSelect(value,index, index2, 'systemValueInputSelectList')">
                                    <a-select-option
                                      v-for="(item, index) in item2.valueOptionsList"
                                      :key="index"
                                      :value="item">
                                      {{ item }}
                                    </a-select-option>
                                  </a-select>
                                  <a-date-picker
                                    v-else
                                    :style="wrapperCol.style"
                                    :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
                                    :showToday="false"
                                    :allowClear="true"
                                    format="YYYY-MM-DD"
                                    :placeholder="`请选择${item2.name}`"
                                    v-model="item2.vaules"
                                    :disabled="item2.status === 2"
                                    style="width: 100%"
                                    @change="(value) => changeParamsDatePicker(value,index, index2, 'systemValueInputSelectList')"
                                  />
                                </a-form-model-item>
                              </a-col>
                            </a-row>
                          </div>
                        </div>
                      </a-tab-pane>
                    </a-tabs>
                  </div>
                </a-tab-pane>
                <a-tab-pane forceRender tab="参数信息" key="parameterInformation">
                  <div class="fieldDiv">
                    <a-tabs @change="changParameterTabs" v-model="parameterTabsKey">
                      <a-tab-pane forceRender v-for="(item, index) in form.paramValueInputSelectList" :tab="item.pName" :key="item.pName">
                        <div class="otherParameters">
                          <a-row :gutter="10">
                            <a-col :span="8" v-for="(item2, index2) in item.children" :key="index2">
                              <a-form-model-item
                                :prop="'paramValueInputSelectList.' + index + '.children.' + index2 + '.vaules'"
                                :rules="{required: item2.status === 1 && item2.requiredState && item.required, message: item2.valueType === 1 ? `请输入${item2.name}` : `请选择${item2.name}`, trigger: item2.valueType === 1 ? 'blur' : 'change'}">
                                <a-tooltip>
                                  <template slot="title">
                                    {{ item2.name }}
                                  </template>
                                  <span
                                    class="titleSpan"
                                    :class="(item2.status === 1 && item2.requiredState) ? 'spanRequired' : ''"
                                    :style="labelCol.style"
                                    style="display: inline-block">{{ item2.name }}：</span>
                                </a-tooltip>
                                <a-input
                                  :style="wrapperCol.style"
                                  v-if="item2.valueType === 1"
                                  :placeholder="`请输入${item2.name}`"
                                  autocomplete="off"
                                  :disabled="item2.status === 2"
                                  v-model="item2.vaules"
                                  @change="(value) => changeParamsInput(value,index, index2, 'paramValueInputSelectList')"
                                />
                                <a-select
                                  v-else-if="item2.valueType === 2"
                                  :style="wrapperCol.style"
                                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                  dropdownClassName="antSelectDropdownMenu200"
                                  :dropdown-style="{ maxHeight: '200px', overflow: 'auto' }"
                                  v-model="item2.vaules"
                                  :disabled="item2.status === 2"
                                  :allowClear="true"
                                  :placeholder="`请选择${item2.name}`"
                                  @change="(value) => changeParamsSelect(value,index, index2, 'paramValueInputSelectList')">
                                  <a-select-option
                                    v-for="(item, index) in item2.valueOptionsList"
                                    :key="index"
                                    :value="item">
                                    {{ item }}
                                  </a-select-option>
                                </a-select>
                                <a-date-picker
                                  v-else
                                  :style="wrapperCol.style"
                                  :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
                                  :showToday="false"
                                  :allowClear="true"
                                  format="YYYY-MM-DD"
                                  :placeholder="`请选择${item2.name}`"
                                  v-model="item2.vaules"
                                  :disabled="item2.status === 2"
                                  style="width: 100%"
                                  @change="(value) => changeParamsDatePicker(value,index, index2, 'paramValueInputSelectList')"
                                />
                              </a-form-model-item>
                            </a-col>
                          </a-row>
                        </div>
                      </a-tab-pane>
                    </a-tabs>
                  </div>
                </a-tab-pane>
                <a-tab-pane forceRender tab="特有信息" key="specificInformation">
                  <div class="specificParameterFieldDiv">
                    <div class="tableHead">
                      <a-row>
                        <a-col :span="12">
                          <div class="tableHeadTitleDiv">
                            <span>字段名称</span>
                          </div>
                        </a-col>
                        <a-col :span="12">
                          <div class="tableHeadTitleDiv">
                            <span>字段值</span>
                          </div>
                        </a-col>
                      </a-row>
                    </div>
                    <div class="tableTrDiv" id="tableTrDiv">
                      <a-row v-for="(item, index) in form.specificParameterList" :key="index" class="tableTrAow">
                        <a-col :span="12">
                          <a-form-model-item
                            :prop="'specificParameterList.' + index + '.value1'"
                            :rules="{required: true, message: '请选择字段名称', trigger: 'blur'}">
                            <a-select
                              show-search
                              :filter-option="filterOption"
                              style="width: 100%"
                              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                              v-model="item.value1"
                              @change="(value) => changeSpecificList(value, index)"
                              placeholder="请选择字段名称">
                              <a-select-option v-for="(item, index) in fieldList" :key="index" :value="item.id" :disabled="item.disabled">
                                {{ item.name }}
                              </a-select-option>
                            </a-select>
                          </a-form-model-item>
                        </a-col>
                        <a-col :span="12" class="fieldValueDiv">
                          <!--                            item.msgName ? item.valueType === 1 ? `请输入${item.msgName}` : `请选择${item.msgName}` : ''-->
                          <a-form-model-item
                            :prop="'specificParameterList.' + index + '.value2'"
                            :rules="{required: true, message: item.msgName ? item.valueType === 1 ? `请输入${item.msgName}` : `请选择${item.msgName}` : '', trigger: item.valueType === 1 ? 'blur' : 'change'}">
                            <a-date-picker
                              v-if="item.valueType === 3"
                              style="width: calc(100% - 12px);"
                              :getCalendarContainer="(triggerNode) => triggerNode.parentNode"
                              :showToday="false"
                              :allowClear="false"
                              format="YYYY-MM-DD"
                              :placeholder="`请选择${item.msgName}`"
                              v-model="item.value2"
                              @change="(value) => changeSpecificListDate(value, index)"
                            />
                            <a-select
                              v-else-if="item.valueType === 2"
                              style="width: calc(100% - 12px);"
                              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                              v-model="item.value2"
                              :placeholder="`请选择${item.msgName}`">
                              <a-select-option
                                v-for="(item, index) in item.selectList"
                                :key="index"
                                :value="item">
                                {{ item }}
                              </a-select-option>
                            </a-select>
                            <a-input v-else v-model="item.value2" class="fieldNameInputDiv" :placeholder="item.msgName ? `请输入${item.msgName}` : ''"></a-input>
                          </a-form-model-item>
                          <a-icon
                            type="close-square"
                            theme="filled"
                            style="color: red;font-size: 20px"
                            @click="removeRow(item, index)"/>
                        </a-col>
                      </a-row>
                      <a-button type="dashed" style="width:100%" @click="addSpecificParameter" block class="add-btn">
                        <a-icon type="plus"/>
                        添加
                      </a-button>
                    </div>
                  </div>
                </a-tab-pane>
              </a-tabs>
            </a-spin>
            <a-row>
              <a-col class="ant-col" :span="24">
                <a-form-model-item
                  :wrapper-col="{ span: 5, offset: 19 }"
                  style="margin-bottom: 0;margin-top: 10px;">
                  <div class="btn">
                    <a-button
                      type="primary"
                      html-type="submit"
                      class="submit"
                      :loading="btnLoading"
                      @click="handleSubmit('formModel')">
                      保存
                    </a-button>
                    <a-button @click="cancel" class="cancel">
                      关闭
                    </a-button>
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
      </div>
    </zm-drawer>
    <a-modal
      :title="modalTitle"
      :visible="modalVisible"
      @cancel="closeModal"
      :width="500"
    >
      <span style="white-space: pre-wrap">{{ modalSpan }}</span>
      <template v-slot:footer>
        <a-button type="primary" @click="copy">复制编码</a-button>
        <a-button @click="closeModal">关闭</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import {
  addOrEditEquipment,
  getDeptTreeList,
  getDictList,
  getEquipmentBasicInfo,
  getParamValuesByEquipmentTypeAndId,
  getUserDepartmentList
} from '@/api/equipmentLedger'
import { getDeviceTypeTree } from '@/api/deviceType'
import moment from 'moment'
import { getUserList } from '@/api/organizationalStructure'
import { getDeptHasBeenConfigured } from '@/api/centralizedDeptManagement'
import tableList from '@/views/sysManagement/role2/list.vue'
import { mapGetters } from 'vuex'
import { getTableData } from '@/api/fieldManage'

export default {
  name: 'DrawerDetail',
  components: { tableList },
  props: {
    // 气体设备用到的
    searchDept: {
      type: String,
      default: ''
    },
    // 气体设备用到的
    searchDeviceType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 抽屉是否显示
      visible: false,
      // 抽屉标题
      title: '',
      footer: false,
      placement: 'right',
      btnLoading: false,
      loading: false,
      // 设备分类改变时tab页的loading
      tabsLoading: false,
      // 公司名称改变时的loading
      companyLoading: false,
      // 归口部门改变时的loading
      relevantdeptLoading: false,
      // 使用部门改变时的loading
      usedeptLoading: false,
      // 顶级tabs的key
      parentTabsKey: 'basicInformationP',
      parentTabsKeyBefore: 'basicInformationP',
      // 基础信息tabs的key
      basicChildrenTabsKey: 'basicInformation',
      basicChildrenTabsKeyBefore: 'basicInformation',
      // 参数信息tabs的key
      parameterTabsKey: '',
      parameterTabsKeyBefore: '',
      form: {
        pName: '',
        sign: 0,
        // 设备数量
        equipmentAmount: null,
        // 设备数量
        unit: undefined,
        // 公司名称
        subcompanyid: undefined,
        // 归口部门
        usedeptid: undefined,
        // 归口部门
        relevantdeptid: undefined,
        // 设备状态
        equipmentStatus: undefined,
        // 专项类型
        specialType: undefined,
        // 首次投用日期
        entryDate: moment().format('YYYY-MM-DD'),
        // 展示方式
        displayType: '1',
        // 特性选择
        peculiarity: [],
        // 参数字段列表
        paramValueInputSelectList: [],
        // 系统字段列表
        systemValueInputSelectList: [],
        // 特有参数列表
        specificParameterList: []
      },
      rules: {
        name: [{ required: true, message: '请输入设备名称!', trigger: 'blur' }]
      },
      // labelCol: { style: 'width: 110px' },
      // wrapperCol: { style: 'width: calc(100% - 120px)' },
      labelCol: { style: 'width: 96px' },
      wrapperCol: { style: 'width: calc(100% - 106px)' },
      showPrincipalName: false,
      // 单位下拉列表
      unitList: [],
      // 公司名称列表
      companyNameList: [],
      // 设备状态列表
      equipmentStatusList: [],
      // 使用人员/归口部门负责人
      userOfServiceList: [],
      // 归口部门负责人
      centralizedDepartmentCenter: [],
      // 归口部门列表
      relevantDepartmentList: [],
      // 使用部门列表
      userDepartmentList: [],
      // 专项类型列表
      specialClassificationList: [],
      // 设备类别列表
      equipmentClassList: [],
      // SAP设备分类列表
      SAPEquipmentClassifyList: [],
      // 重要分类列表
      importantClassificationList: [
        {
          id: 'A',
          name: 'A'
        },
        {
          id: 'B',
          name: 'B'
        },
        {
          id: 'C',
          name: 'C'
        },
        {
          id: 'D',
          name: 'D'
        }
      ],
      // 重要分类列表
      displayModeList: [
        {
          id: '1',
          name: '树状展示'
        },
        {
          id: '2',
          name: '抽屉展示'
        }
      ],
      // 是否列表
      yesOrNoList: [
        {
          id: '是',
          name: '是'
        },
        {
          id: '否',
          name: '否'
        }
      ],
      // 是否列表
      yesOrNoSignList: [
        {
          id: 1,
          name: '是'
        },
        {
          id: 0,
          name: '否'
        }
      ],
      // 采购类型列表
      purchaseTypeList: [
        {
          id: '单一来源',
          name: '单一来源'
        },
        {
          id: '公开招标',
          name: '公开招标'
        },
        {
          id: '询价采购',
          name: '询价采购'
        },
        {
          id: '协议采购',
          name: '协议采购'
        },
        {
          id: '其他采购',
          name: '其他采购'
        }
      ],
      // 售后服务类型列表
      afterSalesServiceList: [
        {
          id: '全国联保',
          name: '全国联保'
        },
        {
          id: '供货商提供',
          name: '供货商提供'
        }
      ],
      plainOptions: ['压力容器', '特种设备', '环保特性'],
      selectList: [],
      fieldList: [],
      disabledFieldList: [],
      model: {},
      // 外部点击的对象，用于插入父子设备时对某些字段的赋值
      dataTabsModel: null,
      type: '',
      // 公司名称code
      subcompanycode: '',
      subcompanyname: '',
      // 公司名称简称
      suburl: '',
      // 使用部门code
      usedeptcode: '',
      // 使用部门name
      usedeptname: '',
      // 归口部门code
      relevantdeptcode: '',
      // 归口部门name
      relevantdeptname: '',
      // 使用人员code
      principalName: '',
      // 归口部门负责人code
      relevantdeptUserName: '',
      // 专项类型名称
      specialTypeName: '',
      // 设备状态名称
      equipmentStatusName: '',
      // SAP设备分类名称
      sapTypeName: '',
      // 设备类别名称
      equipmentTypeName: '',
      equipmentTypeNameOriginal: '',
      equipmentTypeOriginal: '',
      // 添加子设备时传的id
      pid: '',
      // 来源（表格，抽屉）
      source: 'table',
      // 添加父设备时传的id
      sonId: '',

      // 新
      // 是否展开系统字段
      systemUnfold: true,
      // 是否展开参数字段
      parameterUnfold: true,
      // 是否展开特有参数
      specificParameterUnfold: true,
      // 新增成功弹窗Title
      modalTitle: '',
      // 新增成功弹窗是否显示
      modalVisible: false,
      modalSpan: '',
      defaultCheck: '',

      // 必填字段
      requiredField: {
        basicInformation: [
          'name',
          'sign',
          'equipmentAmount',
          'unit',
          'equipmentStatus',
          'equipmentType',
          'specification',
          'interiorCode',
          'subcompanyid',
          'relevantdeptid',
          'usedeptid',
          'brand',
          'displayType'
        ],
        checkPromptObj: {
          'name': '基础信息_基本信息_设备名称',
          'sign': '基础信息_基本信息_是否虚拟设备',
          'equipmentAmount': '基础信息_基本信息_设备数量',
          'unit': '基础信息_基本信息_单位',
          'equipmentStatus': '基础信息_基本信息_设备状态',
          'equipmentType': '基础信息_基本信息_设备分类',
          'specification': '基础信息_基本信息_规格型号',
          'interiorCode': '基础信息_基本信息_内部编码',
          'subcompanyid': '基础信息_基本信息_公司名称',
          'relevantdeptid': '基础信息_基本信息_归口部门',
          'usedeptid': '基础信息_基本信息_使用部门',
          'brand': '基础信息_基本信息_设备品牌',
          'displayType': '基础信息_基本信息_展示方式'
        }
      }
    }
  },
  created () {
    // 获取特有信息tab中的字段名称下拉列表
    this.getFieldList()
    // 获取单位下拉列表
    this.getUnitList()
    // 获取公司名称列表
    this.getCompanyNameList()
    // 获取设备状态列表
    this.getEquipmentStatusList()
    // 获取归口部门列表
    // this.getRelevantDepartmentList()
    // 获取专项分类
    this.getSpecialClassificationList()
    // 获取设备类别
    this.getEquipmentClassList()
    // 获取SAP设备分类列表
    this.getSAPEquipmentClassifyList()
  },
  computed: {
    ...mapGetters(['centralizedManagementCompanyId', 'userInfo'])
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    setPid (pid) {
      this.pid = pid
    },
    setSource (source) {
      this.source = source
    },
    setSonId (sonId) {
      this.sonId = sonId
    },
    setPname (pName) {
      this.form.pName = pName
    },
    setDataTabsModel (dataTabsModel) {
      this.dataTabsModel = dataTabsModel
      console.log(dataTabsModel)
    },
    // 设置model 参数 修改时传入
    setModel (model, type = 'edit') {
      this.loading = true
      getEquipmentBasicInfo({ id: model.id }).then(res => {
        if (res.status === 0) {
          this.$nextTick(async () => {
            const params = res.data
            this.subcompanycode = params.subcompanycode
            this.subcompanyname = params.subcompanyname
            this.suburl = params.suburl
            this.usedeptcode = params.usedeptcode
            this.usedeptname = params.usedeptname
            this.relevantdeptcode = params.relevantdeptcode
            this.relevantdeptname = params.relevantdeptname
            this.specialTypeName = params.specialTypeName
            this.equipmentTypeName = params.equipmentTypeName
            this.equipmentTypeNameOriginal = params.equipmentTypeNameOriginal
            this.equipmentTypeOriginal = params.equipmentType
            this.equipmentStatusName = params.equipmentStatusName
            this.sapTypeName = params.sapTypeName
            this.principalName = params.principalName
            this.relevantdeptUserName = params.relevantdeptUserName
            this.getUserDepartmentList(params.subcompanyid, params.subcompanyname)
            this.getRelevantDepartmentList(params.subcompanyid)
            if (params.usedeptid) {
              this.getUserOfServiceAndCentralizedList(params.usedeptid)
              params.principalId = params.principalId ? params.principalId : 'null'
            } else {
              params.principalId = undefined
            }
            this.getCentralizedDepartmentCenterList(params.relevantdeptid)
            params.dateInProduced = params.dateInProduced ? moment(params.dateInProduced, 'YYYY-MM-DD HH:ss:dd') : ''
            params.entryDate = params.entryDate ? moment(params.entryDate, 'YYYY-MM-DD HH:ss:dd') : ''
            params.maintenanceDate = params.maintenanceDate ? moment(params.maintenanceDate, 'YYYY-MM-DD HH:ss:dd') : ''
            params.purchaseDate = params.purchaseDate ? moment(params.purchaseDate, 'YYYY-MM-DD HH:ss:dd') : ''
            params.producedDate = params.producedDate ? moment(params.producedDate, 'YYYY-MM-DD HH:ss:dd') : ''
            params.retirementDate = params.retirementDate ? moment(params.retirementDate, 'YYYY-MM-DD HH:ss:dd') : ''
            params.specificParameterList = []
            params.paramValueInputSelectList = []
            params.systemValueInputSelectList = []
            params.peculiarity = []
            // 特性选择
            if (params.isYlrqPeculiarity) {
              params.peculiarity.push('压力容器')
            }
            if (params.isTzsbPeculiarity) {
              params.peculiarity.push('特种设备')
            }
            if (params.isHbPeculiarity) {
              params.peculiarity.push('环保特性')
            }
            if (params.fieldValueList) {
              for (const item of params.fieldValueList) {
                const data = {
                  value1: item.fieldId,
                  value2: item.vaules,
                  msgName: item.name,
                  valueType: item.valueType
                }
                if (item.valueType === 2) {
                  if (item.valueOptions) {
                    data.selectList = item.valueOptions.split('、')
                  }
                }
                params.specificParameterList.push(data)
              }
            }
            if (type === 'copy') {
              delete params.equipmentNumber
              delete params.interiorCode
              // delete params.id
            }
            if (params.principalId !== 'null') {
              this.showPrincipalName = false
            } else {
              this.showPrincipalName = true
            }
            this.form = params
            this.model = JSON.parse(JSON.stringify(params))
            await this.resetFieldDisabled()
            await this.getParameterFieldList(params.equipmentType, params.id)
          })
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      if (flag) {
        // 获取归口部门列表
        if (this.type === 'add') {
          console.log(this.centralizedManagementCompanyId)
          this.$nextTick(async () => {
            // 外部选中的是否是公司
            const isCompany = this.centralizedManagementCompanyId.data.isCompany
            this.form.equipmentStatus = this.equipmentStatusList[0].code
            this.form.sign = 0
            this.form.equipmentAmount = 1
            this.form.unit = 'unit_01'
            this.form.displayType = '1'
            if (this.searchDept) {
              // 判断dataTabsModel对象是否有值
              if (this.dataTabsModel) {
                // 当外部点击的时新增父子设备时
                this.getRelevantDepartmentList(this.dataTabsModel.subcompanyid)
                this.getUserDepartmentList(this.dataTabsModel.subcompanyid)
                this.form.subcompanyid = this.dataTabsModel.subcompanyid
                this.form.assetNumber = this.dataTabsModel.assetNumber
                if (this.dataTabsModel.depid) {
                  this.form.usedeptid = this.dataTabsModel.depid
                  this.getUserOfServiceAndCentralizedList(this.dataTabsModel.depid)
                  this.form.principalId = this.dataTabsModel.principalId ? this.dataTabsModel.principalId : 'null'
                } else {
                  this.form.principalId = undefined
                }
                if (this.form.principalId !== 'null') {
                  this.showPrincipalName = false
                } else {
                  this.showPrincipalName = true
                }
                this.form.entryDate = this.dataTabsModel.entryDate ? moment(this.dataTabsModel.entryDate, 'YYYY-MM-DD HH:ss:dd') : ''
                this.form.principalName = this.dataTabsModel.principalName
                this.form.relevantdeptid = this.dataTabsModel.relevantdeptid
                this.form.relevantdeptUserId = this.dataTabsModel.relevantdeptUserId
                this.subcompanycode = this.dataTabsModel.subcompanycode
                this.subcompanyname = this.dataTabsModel.subcompanyname
                this.suburl = this.dataTabsModel.suburl
              } else {
                this.getRelevantDepartmentList(this.defaultCheck[0].id)
                this.getUserDepartmentList(this.defaultCheck[0].id)
                this.form.subcompanyid = this.defaultCheck[0].id
                this.subcompanycode = this.defaultCheck[0].subcompanycode
                this.subcompanyname = this.defaultCheck[0].subcompanyname
                this.suburl = this.defaultCheck[0].suburl
                this.relevantdeptcode = this.defaultCheck[0].departmentcode
                this.relevantdeptname = this.defaultCheck[0].departmentname

                // if (isCompany) {
                //   this.getRelevantDepartmentList(this.centralizedManagementCompanyId.data.id)
                // }
                // if (isCompany) {
                //   this.getUserDepartmentList(this.centralizedManagementCompanyId.data.id)
                // }
                // this.form.subcompanyid = isCompany ? this.centralizedManagementCompanyId.data.id : undefined
                // this.subcompanycode = isCompany ? this.centralizedManagementCompanyId.data.subcompanycode : ''
                // this.subcompanyname = isCompany ? this.centralizedManagementCompanyId.data.subcompanyname : ''
                // this.suburl = isCompany ? this.centralizedManagementCompanyId.data.suburl : ''
                // this.relevantdeptcode = isCompany ? this.centralizedManagementCompanyId.data.departmentcode : ''
                // this.relevantdeptname = isCompany ? this.centralizedManagementCompanyId.data.departmentname : ''
              }
            } else {
              // 判断dataTabsModel对象是否有值
              if (this.dataTabsModel) {
                // 当外部点击的时新增父子设备时
                this.getRelevantDepartmentList(this.dataTabsModel.subcompanyid)
                this.getUserDepartmentList(this.dataTabsModel.subcompanyid)
                this.form.subcompanyid = this.dataTabsModel.subcompanyid
                this.form.assetNumber = this.dataTabsModel.assetNumber
                if (this.dataTabsModel.usedeptid) {
                  this.form.usedeptid = this.dataTabsModel.usedeptid
                  this.getUserOfServiceAndCentralizedList(this.dataTabsModel.usedeptid)
                  this.form.principalId = this.dataTabsModel.principalId ? this.dataTabsModel.principalId : 'null'
                } else {
                  this.form.principalId = undefined
                }
                if (this.form.principalId !== 'null') {
                  this.showPrincipalName = false
                } else {
                  this.showPrincipalName = true
                }
                this.form.entryDate = this.dataTabsModel.entryDate ? moment(this.dataTabsModel.entryDate, 'YYYY-MM-DD HH:ss:dd') : ''
                this.form.principalName = this.dataTabsModel.principalName
                this.form.relevantdeptid = this.dataTabsModel.relevantdeptid
                this.form.relevantdeptUserId = this.dataTabsModel.relevantdeptUserId
                this.subcompanycode = this.dataTabsModel.subcompanycode
                this.subcompanyname = this.dataTabsModel.subcompanyname
                this.suburl = this.dataTabsModel.suburl
              } else {
                // 外部时新增设备时
                // 外部是否有选中公司，如果有则使用外部的，没有则使用默认的第一个
                if (isCompany) {
                  this.getRelevantDepartmentList(this.centralizedManagementCompanyId.data.id)
                }
                if (isCompany) {
                  this.getUserDepartmentList(this.centralizedManagementCompanyId.data.id)
                }
                // this.getRelevantDepartmentList(isCompany ? this.centralizedManagementCompanyId.data.id : this.companyNameList[0].id)
                // this.getUserDepartmentList(isCompany ? this.centralizedManagementCompanyId.data.id : this.companyNameList[0].id)
                this.form.subcompanyid = isCompany ? this.centralizedManagementCompanyId.data.id : undefined
                this.subcompanycode = isCompany ? this.centralizedManagementCompanyId.data.subcompanycode : ''
                this.subcompanyname = isCompany ? this.centralizedManagementCompanyId.data.subcompanyname : ''
                this.suburl = isCompany ? this.centralizedManagementCompanyId.data.suburl : ''
              }
            }
          })
        }
        this.$nextTick(() => {
          document.getElementsByClassName('drawer_body')[0].scrollTop = 0
        })
      }
      this.visible = flag
    },
    validatePass2 (rule, value, callback, item) {
      if (!value) {
        if (item.msgName) {
          if (item.valueType === 1) {
            callback(new Error(`请输入${item.msgName}`))
          } else {
            callback(new Error(`请选择${item.msgName}`))
          }
        } else {
          callback()
        }
      }
    },
    // 去重
    deleteRepetition (arr) {
      const newArr = []
      for (const item of arr) {
        if (newArr.indexOf(item) === -1) {
          newArr.push(item)
        }
      }
      return newArr
    },
    // 获取特有信息tab中的字段名称下拉列表
    getFieldList () {
      const data = {
        paging: false
      }
      getTableData(data).then(res => {
        if (res.status === 0) {
          for (const item of res.data) {
            item.disabled = item.status === 2
          }
          this.fieldList = res.data
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
    },
    // 获取单位下拉列表
    getUnitList () {
      const data = {
        pCode: 'unit'
      }
      getDictList(data).then(res => {
        if (res.status === 0) {
          this.unitList = res.data
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
    },
    // 重置children数组
    resetTheChildrenArray (children) {
      const arr = []
      const self = this
      if (children && children.length > 0) {
        for (let i = 0; i < children.length; i++) {
          const item = JSON.parse(JSON.stringify(children[i]))
          if (item.children && item.children.length) {
            item.disabled = true
            item.children = self.resetTheChildrenArray(item.children)
          } else {
            if (this.searchDept && !this.defaultCheck) {
              this.defaultCheck = children
            }
          }
          arr.push(item)
        }
      }
      return arr
    },
    // 获取公司名称列表
    getCompanyNameList () {
      const data = {
        paging: false
      }
      if (this.searchDept) {
        data.id = this.searchDept
      }
      getDeptTreeList(data).then(res => {
        if (res.status === 0) {
          res.data.map(item => {
            if (item.children.length > 0) {
              item.disabled = true
            } else {
              if (this.searchDept && !this.defaultCheck) {
                this.defaultCheck = item
              }
            }
            item.children = this.resetTheChildrenArray(item.children)
          })
          this.companyNameList = res.data
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 获取设备状态列表
    getEquipmentStatusList () {
      const data = {
        pCode: 'sb_sbzt'
      }
      getDictList(data).then(res => {
        if (res.status === 0) {
          this.equipmentStatusList = res.data
        }
      })
    },
    // 获取归口部门列表
    getRelevantDepartmentList (subcompanyid) {
      const data = {
        subcompanyid: subcompanyid
      }
      getDeptHasBeenConfigured(data).then(res => {
        if (res.status === 0) {
          this.relevantDepartmentList = res.data
          if (res.data.length > 0) {
            if (this.type === 'add') {
              const index = this.relevantDepartmentList.findIndex(item => item.deptId === this.userInfo.departmentid)
              this.form.relevantdeptid = index > -1 ? this.relevantDepartmentList[index].deptId : this.relevantDepartmentList[0].deptId
              this.relevantdeptcode = index > -1 ? this.relevantDepartmentList[index].departmentcode : this.relevantDepartmentList[0].departmentcode
              this.relevantdeptname = index > -1 ? this.relevantDepartmentList[index].departmentname : this.relevantDepartmentList[0].departmentname
              this.getCentralizedDepartmentCenterList(index > -1 ? this.relevantDepartmentList[index].deptId : this.relevantDepartmentList[0].deptId)
            }
          } else {
            this.form.relevantdeptid = undefined
            this.relevantdeptcode = ''
            this.relevantdeptname = ''
            this.centralizedDepartmentCenter = []
          }
        }
      })
    },
    // 获取使用部门列表
    getUserDepartmentList (comid) {
      const data = {
        paging: false,
        comid: comid
      }
      this.companyLoading = true
      getUserDepartmentList(data).then(res => {
        if (res.status === 0) {
          this.userDepartmentList = res.data
          this.companyLoading = false
        } else {
          this.$message.error(res.info.message)
          this.companyLoading = false
        }
      })
    },
    // 获取使用人员
    getUserOfServiceAndCentralizedList (depid) {
      const data = {
        depid: depid,
        paging: false
      }
      this.usedeptLoading = true
      getUserList(data).then(res => {
        if (res.status === 0) {
          this.userOfServiceList = res.data
          if (this.form.principalId !== 'null') {
            if (this.userOfServiceList.findIndex(item => item.id === this.form.principalId) === -1) {
              this.form.principalId = this.form.principalName
            }
          }
          this.usedeptLoading = false
        } else {
          this.usedeptLoading = false
          this.$message.error(res.info.message)
        }
      })
    },
    // 获取归口部门负责人
    getCentralizedDepartmentCenterList (depid) {
      const data = {
        depid: depid,
        paging: false
      }
      this.relevantdeptLoading = true
      getUserList(data).then(res => {
        if (res.status === 0) {
          this.centralizedDepartmentCenter = res.data
          this.relevantdeptLoading = false
        } else {
          this.relevantdeptLoading = false
          this.$message.error(res.info.message)
        }
      })
    },
    // 获取专项类型
    getSpecialClassificationList () {
      const data = {
        pCode: 'sb_zxlx'
      }
      getDictList(data).then(res => {
        if (res.status === 0) {
          this.specialClassificationList = res.data
        }
      })
    },
    // 获取设备类别
    getEquipmentClassList () {
      const data = {}
      if (this.searchDeviceType) {
        data.code = this.searchDeviceType
      }
      getDeviceTypeTree(data).then(res => {
        if (res.status === 0) {
          this.equipmentClassList = res.data
        }
      })
    },
    // 获取SAP设备分类
    getSAPEquipmentClassifyList () {
      const data = {
        pCode: 'zcfl'
      }
      getDictList(data).then(res => {
        if (res.status === 0) {
          this.SAPEquipmentClassifyList = res.data
        }
      })
    },
    // 改变公司选择
    changeCompany (value, label, extra) {
      if (extra.triggerNode) {
        this.subcompanycode = extra.triggerNode.$vnode.data.props.dataRef.subcompanycode
        this.subcompanyname = extra.triggerNode.$vnode.data.props.dataRef.subcompanyname
        this.suburl = extra.triggerNode.$vnode.data.props.dataRef.url
      } else {
        this.subcompanycode = ''
        this.subcompanyname = ''
        this.suburl = ''
      }
      // this.form.setFieldsValue(
      //   {
      //     usedeptid: undefined,
      //     principalId: undefined,
      //     principalName: undefined,
      //     relevantdeptUserId: undefined,
      //     relevantdeptid: undefined
      //   }
      // )
      this.form.usedeptid = undefined
      this.form.principalId = undefined
      this.form.principalName = undefined
      this.form.relevantdeptUserId = undefined
      this.form.relevantdeptid = undefined
      // 重置使用部门下拉列表
      this.userDepartmentList = []
      // 重置使用部门
      this.usedeptcode = ''
      this.usedeptname = ''
      // 重置使用人员/归口部门负责人下拉列表
      this.userOfServiceList = []
      this.centralizedDepartmentCenter = []
      // 重置使用人员
      this.principalName = ''
      // 重置归口部门负责人
      this.relevantdeptcode = ''
      this.relevantdeptname = ''
      this.relevantdeptUserName = ''
      // 获取使用部门
      this.getUserDepartmentList(value)
      this.getRelevantDepartmentList(value)
    },
    // 改变设备类别
    changeEquipmentType (value, label, extra) {
      const that = this
      if (extra.triggerNode) {
        if (this.type === 'add') {
          this.getParameterFieldList(value)
          this.equipmentTypeName = extra.triggerNode.$vnode.data.props.dataRef.name
          this.equipmentTypeNameOriginal = extra.triggerNode.$vnode.data.props.dataRef.name
        } else {
          if (this.form.paramValueInputSelectList || this.form.systemValueInputSelectList) {
            let bol = false
            try {
              const len = this.form.paramValueInputSelectList.length
              for (let i = 0; i < len; i++) {
                const item = this.form.paramValueInputSelectList[i]
                if (item.children) {
                  const childLen = item.children.length
                  for (let j = 0; j < childLen; j++) {
                    const item2 = item.children[j]
                    if (item2.vaules) {
                      throw new Error('有值')
                    }
                  }
                }
              }
            } catch (error) {
              bol = true
            }
            try {
              const len = this.form.systemValueInputSelectList.length
              for (let i = 0; i < len; i++) {
                const item = this.form.systemValueInputSelectList[i]
                if (item.children) {
                  const childLen = item.children.length
                  for (let j = 0; j < childLen; j++) {
                    const item2 = item.children[j]
                    if (item2.vaules) {
                      throw new Error('有值')
                    }
                  }
                }
              }
            } catch (error) {
              bol = true
            }
            if (bol) {
              this.$confirm({
                // title: '设备分类改变时，参数部分的数据将被删除并重新填写，确定是否变化？',
                title: '此时系统参数的值保留，参数信息的值可以直接删除，同时老的设备编码作废，生成的新的设备编码，确定是否变化？',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk () {
                  that.equipmentTypeName = extra.triggerNode.$vnode.data.props.dataRef.name
                  that.equipmentTypeNameOriginal = extra.triggerNode.$vnode.data.props.dataRef.name
                  that.equipmentTypeOriginal = that.form.equipmentType
                  that.getParameterFieldList(value)
                },
                onCancel () {
                  that.form.equipmentType = that.equipmentTypeOriginal
                }
              })
            } else {
              this.equipmentTypeName = extra.triggerNode.$vnode.data.props.dataRef.name
              this.equipmentTypeNameOriginal = extra.triggerNode.$vnode.data.props.dataRef.name
              this.getParameterFieldList(value)
            }
          } else {
            this.equipmentTypeName = extra.triggerNode.$vnode.data.props.dataRef.name
            this.equipmentTypeNameOriginal = extra.triggerNode.$vnode.data.props.dataRef.name
            this.getParameterFieldList(value)
          }
        }
      } else {
        this.equipmentTypeName = ''
        this.equipmentTypeNameOriginal = ''
        this.requiredField = {
          basicInformation: [
            'name',
            'sign',
            'equipmentAmount',
            'unit',
            'equipmentStatus',
            'equipmentType',
            'specification',
            'interiorCode',
            'subcompanyid',
            'relevantdeptid',
            'usedeptid',
            'brand',
            'displayType'
          ],
          checkPromptObj: {
            'name': '基础信息_基本信息_设备名称',
            'sign': '基础信息_基本信息_是否虚拟设备',
            'equipmentAmount': '基础信息_基本信息_设备数量',
            'unit': '基础信息_基本信息_单位',
            'equipmentStatus': '基础信息_基本信息_设备状态',
            'equipmentType': '基础信息_基本信息_设备分类',
            'specification': '基础信息_基本信息_规格型号',
            'interiorCode': '基础信息_基本信息_内部编码',
            'subcompanyid': '基础信息_基本信息_公司名称',
            'relevantdeptid': '基础信息_基本信息_归口部门',
            'usedeptid': '基础信息_基本信息_使用部门',
            'brand': '基础信息_基本信息_设备品牌',
            'displayType': '基础信息_基本信息_展示方式'
          }
        }
        this.form.paramValueInputSelectList = []
        this.form.systemValueInputSelectList = []
        this.disabledFieldList = []
        this.resetFieldDisabled()
      }
      this.$forceUpdate()
    },
    // 改变专项类型
    changeSpecialType (value) {
      if (value) {
        const index = this.specialClassificationList.findIndex(item => item.code === value)
        this.specialTypeName = this.specialClassificationList[index].name
      } else {
        this.specialTypeName = ''
      }
    },
    // 改变设备状态
    changeEquipmentStatus (value) {
      if (value) {
        const index = this.equipmentStatusList.findIndex(item => item.code === value)
        this.equipmentStatusName = this.equipmentStatusList[index].name
      } else {
        this.equipmentStatusName = ''
      }
    },
    // 改变SAP设备分类
    changeSapType (value) {
      if (value) {
        const index = this.SAPEquipmentClassifyList.findIndex(item => item.code === value)
        this.sapTypeName = this.SAPEquipmentClassifyList[index].name
      } else {
        this.sapTypeName = ''
      }
    },
    // 改变归口部门
    changeRelevantDept (value) {
      if (value) {
        const index = this.relevantDepartmentList.findIndex(item => item.deptId === value)
        this.relevantdeptcode = this.relevantDepartmentList[index].departmentcode
        this.relevantdeptname = this.relevantDepartmentList[index].departmentname
        this.getCentralizedDepartmentCenterList(value)
      } else {
        this.relevantdeptcode = ''
        this.relevantdeptname = ''
      }
      //  重置归口部门负责人
      this.$nextTick(() => {
        // this.form.setFieldsValue({
        //   relevantdeptUserId: undefined
        // })
        this.form.relevantdeptUserId = undefined
      })
      this.relevantdeptUserName = ''
    },
    // 改变使用部门选择
    changeUseDept (value, label, extra) {
      if (extra.triggerNode) {
        this.usedeptcode = extra.triggerNode.$vnode.data.props.dataRef.departmentcode
        this.usedeptname = extra.triggerNode.$vnode.data.props.dataRef.departmentname
        this.getUserOfServiceAndCentralizedList(extra.triggerNode.$vnode.data.props.dataRef.depid)
      } else {
        this.usedeptcode = ''
        this.usedeptname = ''
      }
      //  重置使用人员
      this.$nextTick(() => {
        // this.form.setFieldsValue({
        //   principalId: undefined,
        //   principalName: undefined
        // })
        this.form.principalId = undefined
        this.form.principalName = undefined
      })
      this.userOfServiceList = []
      this.principalName = ''
      this.showPrincipalName = false
    },
    // 改变使用人员
    changeUseDeptPersonnel (value) {
      // this.form.setFieldsValue({
      //   principalName: undefined
      // })
      this.form.principalName = undefined
      if (value) {
        if (value === 'null') {
          this.showPrincipalName = true
        } else {
          this.showPrincipalName = false
          const index = this.userOfServiceList.findIndex(item => item.id === value)
          this.principalName = this.userOfServiceList[index].lastname
        }
      } else {
        this.principalName = ''
        this.showPrincipalName = false
      }
      this.$forceUpdate()
    },
    // 改变归口部门负责人
    changeCentralizeDeptPersonnel (value) {
      if (value) {
        const index = this.centralizedDepartmentCenter.findIndex(item => item.id === value)
        this.relevantdeptUserName = this.centralizedDepartmentCenter[index].lastname
      } else {
        this.relevantdeptUserName = ''
      }
    },
    // 搜索使用部门
    filterTreeNode (inputValue, treeNode) {
      return treeNode.data.props.title.includes(inputValue)
    },
    // 根据设备分类获取参数字段
    getParameterFieldList (value, id) {
      // 使用modifiedField方法，遍历每一个children中的valueOptions字段，并将其转换为数组
      const modifiedField = (data) => {
        data.forEach((item, index) => {
          if (item.valueOptions) {
            item.valueOptionsList = item.valueOptions.split('、')
          }
          if (item.children) {
            modifiedField(item.children)
          }
        })
      }
      const params = {
        equipmentType: value
      }
      if (this.type === 'edit' || this.type === 'copy' && id) {
        params.equipmentId = id
      }
      this.disabledFieldList = []
      this.loading = true
      getParamValuesByEquipmentTypeAndId(params).then(res => {
        if (res.status === 0) {
          if (res.data.length > 0) {
            modifiedField(res.data)
            const paramValueInputSelectList = []
            const systemValueInputSelectList = []
            res.data.forEach((item, index) => {
              if (!item.isSystem) {
                paramValueInputSelectList.push(item)
              } else {
                systemValueInputSelectList.push(item)
              }
            })
            paramValueInputSelectList.forEach((item, index) => {
              item.required = false
              this.requiredField[item.pName] = []
              item.children.forEach((item2, index2) => {
                if (item2.status === 1 && item2.requiredState) {
                  // 必填字段
                  let prop = ''
                  let value = ''
                  // 参数信息字段
                  prop = 'paramValueInputSelectList.' + index + '.children.' + index2 + '.vaules'
                  value = '参数信息_' + item.pName + '_' + item2.name
                  this.requiredField[item.pName].push(prop)
                  this.requiredField.checkPromptObj[prop] = value
                }
                if (item2.vaules) {
                  item.required = true
                } else {
                  item2.vaules = undefined
                }
                this.disabledFieldList.push(item2.fieldId)
              })
            })
            systemValueInputSelectList.forEach((item, index) => {
              item.required = false
              this.requiredField[item.pName] = []
              item.children.forEach((item2, index2) => {
                if (item2.status === 1 && item2.requiredState) {
                  // 必填字段
                  let prop = ''
                  let value = ''
                  // 系统字段
                  prop = 'systemValueInputSelectList.' + index + '.children.' + index2 + '.vaules'
                  value = '基础信息_' + item.pName + '_' + item2.name
                  this.requiredField[item.pName].push(prop)
                  this.requiredField.checkPromptObj[prop] = value
                }
                if (item2.vaules) {
                  item.required = true
                } else {
                  item2.vaules = undefined
                }
                this.disabledFieldList.push(item2.fieldId)
              })
            })
            // this.resetFieldDisabled()
            // this.parameterTabsKey = paramValueInputSelectList.length > 0 ? paramValueInputSelectList[0].pName : ''
            // this.parameterTabsKeyBefore = paramValueInputSelectList.length > 0 ? paramValueInputSelectList[0].pName : ''
            // this.form.paramValueInputSelectList = paramValueInputSelectList
            // this.form.systemValueInputSelectList = systemValueInputSelectList
            this.oldValueToNewValue(paramValueInputSelectList, systemValueInputSelectList)
          } else {
            this.form.paramValueInputSelectList = []
            this.form.systemValueInputSelectList = []
            this.resetFieldDisabled()
          }
          this.loading = false
          this.$forceUpdate()
        } else {
          this.$message.error(res.info.message)
          this.loading = false
        }
      })
        .catch(err => {
          this.loading = false
          this.$message.error(err.info.message)
        })
    },
    /**
     * 把旧值赋值给新值
     */
    oldValueToNewValue (paramValueInputSelectList, systemValueInputSelectList) {
      this.form.paramValueInputSelectList.forEach((item, index) => {
        item.children.forEach((item2, index2) => {
          for (const item3 of paramValueInputSelectList) {
            const childNewIndex = item3.children.findIndex(item4 => item4.name === item2.name)
            if (childNewIndex > -1) {
              if (item2.vaules) {
                item3.children[childNewIndex].vaules = item2.vaules
              }
            }
          }
        })
      })
      this.form.systemValueInputSelectList.forEach((item, index) => {
        item.children.forEach((item2, index2) => {
          for (const item3 of systemValueInputSelectList) {
            const childNewIndex = item3.children.findIndex(item4 => item4.name === item2.name)
            if (childNewIndex > -1) {
              if (item2.vaules) {
                item3.children[childNewIndex].vaules = item2.vaules
              }
            }
          }
        })
      })
      // this.form.systemValueInputSelectList.forEach((item, index) => {
      //   const newIndex = systemValueInputSelectList.findIndex(item2 => item2.pName === item.pName)
      //   if (newIndex > -1) {
      //     item.children.forEach((item2, index2) => {
      //       if (systemValueInputSelectList[newIndex] && systemValueInputSelectList[newIndex].children) {
      //         const childNewIndex = systemValueInputSelectList[newIndex].children.findIndex(item3 => item3.name === item2.name)
      //         if (childNewIndex > -1) {
      //           if (item2.vaules) {
      //             systemValueInputSelectList[newIndex].children[childNewIndex].vaules = item2.vaules
      //           }
      //         }
      //       }
      //     })
      //   }
      // })
      this.resetFieldDisabled()
      this.parameterTabsKey = paramValueInputSelectList.length > 0 ? paramValueInputSelectList[0].pName : ''
      this.parameterTabsKeyBefore = paramValueInputSelectList.length > 0 ? paramValueInputSelectList[0].pName : ''
      this.form.paramValueInputSelectList = paramValueInputSelectList
      this.form.systemValueInputSelectList = systemValueInputSelectList
    },
    /**
     * 参数信息中判断当前模块是否需要校验
     * @param {Number} index 当前模块的索引
     * @param {String} formKey form中的key
     */
    determineWhetherToCheck (index, formKey) {
      let bol = false
      const propList = []
      console.log(index, formKey)
      console.log(this.form[formKey][index])
      this.form[formKey][index].children.forEach((data, dataIndex) => {
        // 当前模块有字段填写了值
        if (data.vaules) {
          bol = true
        }
        if (data.status === 1 && data.requiredState) {
          // 把必填字段的prop加入到propList中
          const prop = formKey + '.' + index + '.children.' + dataIndex + '.vaules'
          propList.push(prop)
        }
      })
      if (bol) {
        // 把当前的必填字段的prop加入到this.requiredField中
        propList.forEach(item => {
          this.requiredField[this.form[formKey][index].pName].push(item)
        })
        // 去重
        this.requiredField[this.form[formKey][index].pName] = this.deleteRepetition(this.requiredField[this.form[formKey][index].pName])
      } else {
        // 把当前的必填字段的prop从this.requiredField中删除
        propList.forEach(item => {
          const indexProp = this.requiredField[this.form[formKey][index].pName].findIndex(item2 => item2 === item)
          this.requiredField[this.form[formKey][index].pName].splice(indexProp, 1)
        })
      }
      this.form[formKey][index].required = bol
    },
    // 改变动态字段中的下拉选择器回调，遍历this.form.paramValueInputSelectList, 将this.form.paramValueInputSelectList中的fieldId与定义的fieldId字段相同的对象的vaules字段赋值value
    changeParamsSelect (value, index, index2, formKey) {
      const arr = [
        'paramValueInputSelectList',
        'systemValueInputSelectList'
      ]
      const fieldId = this.form[formKey][index].children[index2].fieldId
      for (const arrElement of arr) {
        // this.determineWhetherToCheck(index, arrElement)
        this.form[arrElement].forEach((item, dataIndex) => {
          if (item.children) {
            item.children.forEach(child => {
              if (child.fieldId === fieldId) {
                child.vaules = value
                this.determineWhetherToCheck(dataIndex, arrElement)
              }
            })
          }
        })
      }
      this.$forceUpdate()
    },
    // 改变动态字段中的输入框回调
    changeParamsInput (value, index, index2, formKey) {
      const arr = [
        'paramValueInputSelectList',
        'systemValueInputSelectList'
      ]
      const fieldId = this.form[formKey][index].children[index2].fieldId
      for (const arrElement of arr) {
        // this.determineWhetherToCheck(index, arrElement)
        this.form[arrElement].forEach((item, dataIndex) => {
          if (item.children) {
            item.children.forEach(child => {
              if (child.fieldId === fieldId) {
                child.vaules = value.target.value
                this.determineWhetherToCheck(dataIndex, arrElement)
              }
            })
          }
        })
      }
      this.$forceUpdate()
    },
    // 改变动态字段中的日期选择回调
    changeParamsDatePicker (value, index, index2, formKey) {
      const arr = [
        'paramValueInputSelectList',
        'systemValueInputSelectList'
      ]
      const fieldId = this.form[formKey][index].children[index2].fieldId
      for (const arrElement of arr) {
        // this.determineWhetherToCheck(index, arrElement)
        this.form[arrElement].forEach((item, dataIndex) => {
          if (item.children) {
            item.children.forEach(child => {
              if (child.fieldId === fieldId) {
                if (value) {
                  child.vaules = value.format('YYYY-MM-DD')
                } else {
                  child.vaules = null
                }
                this.determineWhetherToCheck(dataIndex, arrElement)
              }
            })
          }
        })
      }
      this.$forceUpdate()
    },
    // 重置fieldList的disabled
    resetFieldDisabled () {
      this.fieldList.forEach(i => {
        i.disabled = i.status === 2
      })
      this.form.specificParameterList.forEach(i => {
        if (i.value1) {
          const index = this.fieldList.findIndex(item2 => item2.id === i.value1)
          this.fieldList[index].disabled = true
        }
      })
      for (const item of this.disabledFieldList) {
        const index = this.fieldList.findIndex(item2 => item2.id === item)
        if (index > -1) {
          this.fieldList[index].disabled = true
        }
      }
    },
    // 改变特有参数中的字段名称回调
    changeSpecificList (value, index) {
      const fieldIndex = this.fieldList.find(item => item.id === value)
      this.form.specificParameterList[index].valueType = fieldIndex.valueType
      this.form.specificParameterList[index].value2 = undefined
      this.form.specificParameterList[index].msgName = fieldIndex.name
      if (fieldIndex.valueType === 2) {
        if (fieldIndex.valueOptions) {
          this.form.specificParameterList[index].selectList = fieldIndex.valueOptions.split('、')
        }
      }
      this.resetFieldDisabled()
      const key = 'specificParameterList.' + index + '.value2'
      this.$refs.formModel.clearValidate(key)
    },
    // 搜索特有参数中的字段名称
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input) >= 0
      )
    },
    // 改变特有参数中的字段名称回调
    changeSpecificListDate (value, index) {
      this.form.specificParameterList[index].value2 = value.format('YYYY-MM-DD')
    },
    // 添加特有参数
    addSpecificParameter () {
      this.form.specificParameterList.push({
        value1: '',
        value2: ''
      })
      const div = document.getElementsByClassName('specificParameterFieldDiv')[0]
      this.$nextTick(() => {
        div.scrollTop = div.scrollHeight
      })
      // 'specificParameterList.' + index + '.value1'
      const index = this.form.specificParameterList.length - 1
      const key1 = 'specificParameterList.' + index + '.value1'
      const key2 = 'specificParameterList.' + index + '.value2'
      this.requiredField.checkPromptObj[key1] = '特有参数_字段名称'
      this.requiredField.checkPromptObj[key2] = '特有参数_字段值'
    },
    // 删除特有参数
    removeRow (item, index) {
      const keyIndex = this.form.specificParameterList.length - 1
      const key1 = 'specificParameterList.' + keyIndex + '.value1'
      const key2 = 'specificParameterList.' + keyIndex + '.value2'
      delete this.requiredField.checkPromptObj[key1]
      delete this.requiredField.checkPromptObj[key2]
      const keyList = []
      for (let i = 0; i < this.form.specificParameterList.length; i++) {
        const key = 'specificParameterList.' + i + '.value2'
        keyList.push(key)
      }
      this.$refs.formModel.clearValidate(keyList)
      this.form.specificParameterList.splice(index, 1)
      this.resetFieldDisabled()
    },
    // 复制
    copy () {
      var aux = document.createElement('input')
      aux.setAttribute('value', this.modalSpan)
      document.body.appendChild(aux)
      aux.select()
      document.execCommand('copy')
      document.body.removeChild(aux)
      this.$message.success('复制成功')
    },
    // 改变基础信息/参数信息/特有信息tabs回调
    changeParentTabs (v) {
      // if (this.parentTabsKeyBefore === 'basicInformationP') {
      //   // 当前tabs是基础信息
      //   if (this.requiredField[this.basicChildrenTabsKeyBefore]) {
      //     let bol = true
      //     this.$refs.formModel.validateField(this.requiredField[this.basicChildrenTabsKeyBefore], (errMsg) => {
      //       if (errMsg !== '') {
      //         bol = false
      //       }
      //     })
      //     if (!bol) {
      //       this.parentTabsKey = this.parentTabsKeyBefore
      //     } else {
      //       this.parentTabsKey = v
      //       this.parentTabsKeyBefore = v
      //     }
      //   } else {
      //     this.parentTabsKey = v
      //     this.parentTabsKeyBefore = v
      //   }
      // } else if (this.parentTabsKeyBefore === 'parameterInformation') {
      //   // 当前tabs是参数信息
      //   if (this.requiredField[this.parameterTabsKeyBefore]) {
      //     let bol = true
      //     this.$refs.formModel.validateField(this.requiredField[this.parameterTabsKeyBefore], (errMsg) => {
      //       if (errMsg !== '') {
      //         bol = false
      //       }
      //     })
      //     if (!bol) {
      //       this.parentTabsKey = this.parentTabsKeyBefore
      //     } else {
      //       this.parentTabsKey = v
      //       this.parentTabsKeyBefore = v
      //     }
      //   } else {
      //     this.parentTabsKey = v
      //     this.parentTabsKeyBefore = v
      //   }
      // } else {
      //   this.parentTabsKey = v
      //   this.parentTabsKeyBefore = v
      // }
    },
    // 改变基础信息tabs下面的tabs回调
    changBasicChildrenTabs (v) {
      // if (this.requiredField[this.basicChildrenTabsKeyBefore]) {
      //   let bol = true
      //   this.$refs.formModel.validateField(this.requiredField[this.basicChildrenTabsKeyBefore], (errMsg) => {
      //     if (errMsg !== '') {
      //       bol = false
      //     }
      //   })
      //   if (!bol) {
      //     this.basicChildrenTabsKey = this.basicChildrenTabsKeyBefore
      //   } else {
      //     this.basicChildrenTabsKey = v
      //     this.basicChildrenTabsKeyBefore = v
      //   }
      // } else {
      //   this.basicChildrenTabsKey = v
      //   this.basicChildrenTabsKeyBefore = v
      // }
    },
    // 改变参数信息tabs下面的tabs回调
    changParameterTabs (v) {
      // if (this.requiredField[this.parameterTabsKeyBefore]) {
      //   let bol = true
      //   this.$refs.formModel.validateField(this.requiredField[this.parameterTabsKeyBefore], (errMsg) => {
      //     if (errMsg !== '') {
      //       bol = false
      //     }
      //   })
      //   if (!bol) {
      //     this.parameterTabsKey = this.parameterTabsKeyBefore
      //   } else {
      //     this.parameterTabsKey = v
      //     this.parameterTabsKeyBefore = v
      //   }
      // } else {
      //   this.parameterTabsKey = v
      //   this.parameterTabsKeyBefore = v
      // }
    },
    // 整理params数据
    organizeParamsData () {
      const params = JSON.parse(JSON.stringify(this.form))
      // 用来整理动态参数
      const modifiedChildren = () => {
        params.paramValueList = []
        const arr = [...this.form.systemValueInputSelectList, ...this.form.paramValueInputSelectList]
        arr.forEach(item => {
          if (item.children) {
            item.children.forEach(child => {
              params.paramValueList.push(child)
            })
          }
        })
      }
      //  用来判断是否有必填项未填
      const checkRequired = () => {
        const list = [
          this.form.systemValueInputSelectList,
          this.form.paramValueInputSelectList
        ]
        for (const listItem of list) {
          for (const item of listItem) {
            if (item.children) {
              for (const child of item.children) {
                if (child.status === 1 && child.requiredState && !child.vaules) {
                  return 1
                }
              }
            }
          }
        }
      }
      modifiedChildren()
      params.subcompanycode = this.subcompanycode
      params.subcompanyname = this.subcompanyname
      params.suburl = this.suburl
      params.usedeptcode = this.usedeptcode
      params.usedeptname = this.usedeptname
      params.relevantdeptcode = this.relevantdeptcode
      params.relevantdeptname = this.relevantdeptname
      params.specialTypeName = this.specialTypeName
      params.equipmentTypeName = this.equipmentTypeName
      params.equipmentStatusName = this.equipmentStatusName
      params.sapTypeName = this.sapTypeName ? this.sapTypeName : null
      params.principalName = params.principalId === 'null' ? params.principalName : this.principalName
      params.relevantdeptUserName = this.relevantdeptUserName
      params.dateInProduced = params.dateInProduced ? moment(params.dateInProduced).format('YYYY-MM-DD 00:00:00') : ''
      params.entryDate = params.entryDate ? moment(params.entryDate).format('YYYY-MM-DD 00:00:00') : ''
      params.maintenanceDate = params.maintenanceDate ? moment(params.maintenanceDate).format('YYYY-MM-DD 00:00:00') : ''
      params.purchaseDate = params.purchaseDate ? moment(params.purchaseDate).format('YYYY-MM-DD 00:00:00') : ''
      params.producedDate = params.producedDate ? moment(params.producedDate).format('YYYY-MM-DD 00:00:00') : ''
      params.retirementDate = params.retirementDate ? moment(params.retirementDate).format('YYYY-MM-DD 00:00:00') : ''
      params.fieldValueList = []
      if (params.specificParameterList) {
        params.specificParameterList.forEach((item, index) => {
          const obj = {
            fieldId: item.value1,
            name: item.msgName,
            vaules: item.value2
          }
          params.fieldValueList.push(obj)
        })
      }
      params.required = checkRequired() ? checkRequired() : 0
      params.unitName = this.unitList.find(item => item.code === params.unit).name
      params.isYlrqPeculiarity = !!params.peculiarity.includes('压力容器')
      params.isTzsbPeculiarity = !!params.peculiarity.includes('特种设备')
      params.isHbPeculiarity = !!params.peculiarity.includes('环保特性')
      if (this.type === 'copy') {
        delete params.id
      }
      delete params.paramValueInputSelectList
      delete params.systemValueInputSelectList
      delete params.specificParameterList
      if (params.principalId === 'null') {
        params.principalId = null
      }
      if (this.pid || this.model.pid) {
        params.pid = this.pid ? this.pid : this.model.pid
      }
      if (this.sonId || this.model.sonId) {
        params.sonId = this.sonId ? this.sonId : this.model.sonId
      }
      return params
    },
    // 提交
    async handleSubmit (formName) {
      this.btnLoading = true
      this.$refs[formName].validate((valid, obj) => {
        if (valid) {
          const reg = /[a-zA-Z]+/
          const reg2 = /^\d.*$/
          const params = this.organizeParamsData()
          if (params.assetNumber && !reg2.test(params.assetNumber)) {
            this.$message.error('资产编号首位必须为数字')
            this.btnLoading = false
            return
          }
          if (params.assetNumber && reg.test(params.assetNumber)) {
            this.$message.error('资产编号不能包含字母')
            this.btnLoading = false
            return
          }
          addOrEditEquipment(params).then(res => {
            if (res.status === 0) {
              res.data.forEach((item, index) => {
                if (index === 0) {
                  this.modalSpan = item.equipmentNumber
                } else {
                  if (index % 4 === 0) {
                    this.modalSpan = this.modalSpan + '，\n' + item.equipmentNumber
                  } else {
                    this.modalSpan = this.modalSpan + '，' + item.equipmentNumber
                  }
                }
                if (item.pnode) {
                  item.children = []
                } else {
                  delete item.children
                }
              })
              this.$message.success('保存成功')
              if (this.source === 'table') {
                if (this.pid) {
                  this.$emit('setChildrenData', res.data, res.data.length)
                } else {
                  if (this.type === 'edit') {
                    this.$emit('updateData', res.data[0])
                  } else {
                    this.$emit('getTableData', false)
                  }
                }
                this.$emit('getDataTabs', res.data[0].id)
              } else {
                this.$emit('getTableData')
              }
              this.btnLoading = false
              if (this.type === 'add' || this.type === 'copy') {
                this.modalTitle = `"${params.name}"已成功创建${params.equipmentAmount}条，设备编码如下:`
                this.modalVisible = true
              } else {
                this.cancel()
              }
            } else {
              this.$message.error(res.info.message)
              this.btnLoading = false
            }
          })
        } else {
          const checkPromptList = []
          let msg = `当前存在以下必填字段没有填写:`
          for (const objKey in obj) {
            // 用于弹窗提示当前未填写的字段
            const msgName = this.requiredField.checkPromptObj[objKey]
            if (checkPromptList.indexOf(msgName) === -1) {
              checkPromptList.push(msgName)
              msg += `<br/>${msgName}`
            }
          }
          // 当前存在以下必填字段没有填写
          this.$confirm({
            title: (h) => {
              return h('div', {
                domProps: {
                  innerHTML: msg
                }
              })
            },
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk () {

            },
            onCancel () {

            }
          })
          this.btnLoading = false
        }
      })
    },
    // 关闭弹窗
    closeModal () {
      this.modalVisible = false
      this.cancel()
    },
    // 关闭抽屉
    cancel () {
      this.formClear('formModel')
      this.open(false)
    },
    // 重置
    formClear (formName) {
      this.$nextTick(() => {
        // this.form.resetFields()
        this.$refs[formName].resetFields()
        this.userDepartmentList = []
        this.userOfServiceList = []
        // 重置使用人员
        this.principalName = ''
        this.showPrincipalName = false
        // 重置归口部门负责人
        this.relevantdeptUserName = ''
        this.subcompanycode = ''
        this.subcompanyname = ''
        this.suburl = ''
        this.usedeptcode = ''
        this.usedeptname = ''
        this.relevantdeptcode = ''
        this.relevantdeptname = ''
        this.specialTypeName = ''
        this.equipmentTypeName = ''
        this.equipmentTypeNameOriginal = ''
        this.equipmentTypeOriginal = ''
        this.equipmentStatusName = ''
        this.sapTypeName = ''
        this.pid = ''
        this.sonId = ''
        this.model = {}
        this.dataTabsModel = null
        this.systemUnfold = true
        this.parameterUnfold = true
        this.specificParameterUnfold = true
        this.form = {
          pName: '',
          sign: 0,
          // 设备数量
          equipmentAmount: null,
          // 设备数量
          unit: undefined,
          // 公司名称
          subcompanyid: '',
          // 归口部门
          relevantdeptid: undefined,
          // 设备状态
          equipmentStatus: undefined,
          // 专项类型
          specialType: undefined,
          // 首次投用日期
          entryDate: moment().format('YYYY-MM-DD'),
          // 展示方式
          displayType: '1',
          // 参数字段列表
          paramValueInputSelectList: [],
          // 系统字段列表
          systemValueInputSelectList: [],
          // 特有参数列表
          specificParameterList: []
        }
        this.requiredField = {
          basicInformation: [
            'name',
            'sign',
            'equipmentAmount',
            'unit',
            'equipmentStatus',
            'equipmentType',
            'specification',
            'interiorCode',
            'subcompanyid',
            'relevantdeptid',
            'usedeptid',
            'brand',
            'displayType'
          ],
          checkPromptObj: {
            'name': '基础信息_基本信息_设备名称',
            'sign': '基础信息_基本信息_是否虚拟设备',
            'equipmentAmount': '基础信息_基本信息_设备数量',
            'unit': '基础信息_基本信息_单位',
            'equipmentStatus': '基础信息_基本信息_设备状态',
            'equipmentType': '基础信息_基本信息_设备分类',
            'specification': '基础信息_基本信息_规格型号',
            'interiorCode': '基础信息_基本信息_内部编码',
            'subcompanyid': '基础信息_基本信息_公司名称',
            'relevantdeptid': '基础信息_基本信息_归口部门',
            'usedeptid': '基础信息_基本信息_使用部门',
            'brand': '基础信息_基本信息_设备品牌',
            'displayType': '基础信息_基本信息_展示方式'
          }
        }
        this.parentTabsKey = 'basicInformationP'
        this.parentTabsKeyBefore = 'basicInformationP'
        this.basicChildrenTabsKey = 'basicInformation'
        this.basicChildrenTabsKeyBefore = 'basicInformation'
        this.parameterTabsKey = ''
        this.parameterTabsKeyBefore = ''
        this.fieldList.forEach(i => {
          i.disabled = i.status === 2
        })
      })
    }
  }
}
</script>

<style scoped lang="less">
.drawerBody {
  height: 100%;
  /deep/.ant-form {
    height: 100%;
    .ant-spin-nested-loading {
      height: calc(100% - 42px);
      .ant-spin-container {
        height: 100%;
        .ant-tabs-content-animated {
          height: calc(100% - 60px);
          .ant-tabs {
            height: 100%;
          }
        }
      }
    }
  }
}
.tabb {
  height: 100% !important;
}
.height100 {
  overflow: visible !important;
  max-height: 100% !important;
}
.maxHeightFieldDiv {
  max-height: 215px;
}
.maxHeight {
  max-height: 225px;
}

.fieldDiv, .specificParameterFieldDiv {
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
  //border-bottom: 1px solid #F1F1F1;
  //margin-bottom: 13px;
  //padding-bottom: 10px;
  .fieldTitleDiv {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 14px;

    .upOrDownIcon {
      margin-left: 12px;
      cursor: pointer;
    }
  }

  .tableHead {
    background-color: rgba(245, 245, 245, 1);

    .tableHeadTitleDiv {
      padding: 10px 8px;
      border: 1px solid #DDDDDD;
    }
  }

  /deep/ .ant-form-item-control-wrapper {
    width: 100%;

    .ant-form-item-children {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.fieldDiv {
  /deep/ .ant-form-explain {
    position: absolute;
    margin-left: 102px;
  }
  /deep/ .ant-form-item {
    margin-bottom: 15px !important;
  }
}
.specificParameterFieldDiv {
  .tableTrDiv {
    margin-top: 8px;

    .tableTrAow {
      margin-bottom: 20px;

      .fieldNameInputDiv {
        width: calc(100% - 12px);
      }

      .fieldValueDiv {
        display: flex;
        flex-direction: row;
        align-items: center;

        .fieldValueInputDiv {
          width: calc(100% - 35px);
          margin-right: 8px;
        }
      }
    }

    .add-btn {
      margin: 0 0 12px 0;
    }
  }
  /deep/ .ant-form-explain {
    position: absolute;
    margin-left: 5px;
  }
  /deep/ .ant-form-item {
    margin-bottom: 0px !important;
  }
}

.titleDiv {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 8px;

  .title {
    border-left: 4px solid #08409F;
    padding-left: 8px;
    color: #08409F;
    margin-right: 12px;
  }
}

.inputDiv {
  background-color: #f5f5f5;
  cursor: not-allowed;
  opacity: 1;
}

.btn {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  .cancel {
    margin-left: 20px;
  }
}

.titleSpan {
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
  text-align: right;
}

.spanRequired:before {
  display: inline-block;
  margin-right: 4px;
  color: #f5222d;
  font-size: 12px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: '*';
}
/deep/ .ant-form-item {
  width: 100%;
}
/deep/ .ant-col-md-5 {
  width: 20% !important;
  margin-bottom: 12px;
}

/deep/ .ant-col-md-9 {
  width: 40% !important;
  margin-bottom: 12px;
}
/deep/.antSelectDropdownMenu200 {
  background-color: #fff;
  .ant-select-dropdown-content {
    .ant-select-dropdown-menu {
      max-height: 200px !important;
    }
  }
}
/deep/.ant-spin-nested-loading {
  .ant-spin-spinning {
    .ant-spin-dot {
      top: calc(50% - 5px);
    }
  }
}
/deep/.ant-calendar-picker {
  .ant-calendar-picker-clear {
    top: calc(50% + 1px) !important;
  }
}
/deep/.ant-select {
  .ant-select-selection__clear {
    top: calc(50% - 1px) !important;
  }
}
</style>
